import { render, staticRenderFns } from "./materialInfo.vue?vue&type=template&id=0b2f53b1&scoped=true"
import script from "./materialInfo.vue?vue&type=script&lang=js"
export * from "./materialInfo.vue?vue&type=script&lang=js"
import style0 from "./materialInfo.vue?vue&type=style&index=0&id=0b2f53b1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2f53b1",
  null
  
)

export default component.exports